import { render, staticRenderFns } from "./BringSameOptions.vue?vue&type=template&id=0643abb6&scoped=true&"
import script from "./BringSameOptions.vue?vue&type=script&lang=js&"
export * from "./BringSameOptions.vue?vue&type=script&lang=js&"
import style0 from "./BringSameOptions.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BringSameOptions.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./BringSameOptions.vue?vue&type=style&index=2&id=0643abb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0643abb6",
  null
  
)

export default component.exports